var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import React from 'react';
import urlApi from './urlApi';
import { COMMENT_EDIT_MODE, COMMENT_INIT_OFFSET, COMMENT_OFFSET, COMMENTS_ALLOWED_TYPE, SUB_COMMENT_OFFSET } from '../components/desktopApp/comments/const/const';
import { API } from '@brg/api';
export var FETCH_INIT_CHAT_DATA = 'FETCH_INIT_CHAT_DATA';
export var FETCH_INIT_CHAT_DATA_SUCCESS = 'FETCH_INIT_CHAT_DATA_SUCCESS';
export var FETCH_INIT_CHAT_DATA_REJECTED = 'FETCH_INIT_CHAT_DATA_REJECTED';
export var FETCH_CHAT_DATA = 'FETCH_CHAT_DATA';
export var FETCH_CHAT_DATA_SUCCESS = 'FETCH_CHAT_DATA_SUCCESS';
export var FETCH_CHAT_DATA_REJECTED = 'FETCH_CHAT_DATA_REJECTED';
export var FETCH_MORE_CHAT_DATA = 'FETCH_CHAT_DATA';
export var FETCH_MORE_CHAT_DATA_SUCCESS = 'FETCH_CHAT_DATA_SUCCESS';
export var FETCH_MORE_CHAT_DATA_REJECTED = 'FETCH_CHAT_DATA_REJECTED';
export var FETCH_MORE_COMMENTS = 'FETCH_MORE_COMMENTS';
export var FETCH_MORE_COMMENTS_SUCCESS = 'FETCH_MORE_COMMENTS_SUCCESS';
export var FETCH_MORE_COMMENTS_REJECT = 'FETCH_MORE_COMMENTS_REJECT';
export var UPDATE_COMMENT_START = 'UPDATE_COMMENT_START';
export var UPDATE_COMMENT_END = 'UPDATE_COMMENT_END';
export var UPDATE_CHAT_DATA = 'UPDATE_CHAT_DATA';
export var UPDATE_COMMENT_STATUS = 'UPDATE_COMMENT_STATUS';
export var UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';
export var UPDATE_SCROLL = 'UPDATE_SCROLL';
export var RESET_STATE = 'RESET_STATE';
var isFirstComment = function (posts, postEntityId) {
    return !(posts === null || posts === void 0 ? void 0 : posts.find(function (p) { return (p === null || p === void 0 ? void 0 : p.entityId) === postEntityId; }));
};
var isFirstSubComment = function (posts, postEntityId, answerId) {
    var _a, _b;
    var post = posts === null || posts === void 0 ? void 0 : posts.find(function (p) { return (p === null || p === void 0 ? void 0 : p.entityId) === postEntityId; });
    var comment = (_b = (_a = post === null || post === void 0 ? void 0 : post.pageModel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.find(function (comment) {
        return (comment === null || comment === void 0 ? void 0 : comment.id) === answerId;
    });
    var subComments = comment === null || comment === void 0 ? void 0 : comment.comments;
    return subComments === null;
};
var getInitialPaging = function (isAnswer) {
    if (isAnswer) {
        return {
            count: 1,
            limit: SUB_COMMENT_OFFSET,
            page: 1,
            pages: 1,
            offset: 0
        };
    }
    return {
        count: 1,
        limit: COMMENT_OFFSET,
        page: 1,
        pages: 1,
        offset: 0
    };
};
var mergeMore = function (_a) {
    var entityId = _a.entityId, entityType = _a.entityType, cData = _a.cData, nData = _a.nData;
    var newData = cData.map(function (c) {
        var _a, _b, _c;
        if (c.entityId === entityId) {
            return __assign(__assign({}, c), { pageModel: {
                    paging: nData.paging,
                    data: __spreadArray(__spreadArray([], (!!((_b = (_a = c === null || c === void 0 ? void 0 : c.pageModel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) ? (_c = c === null || c === void 0 ? void 0 : c.pageModel) === null || _c === void 0 ? void 0 : _c.data : []), true), nData === null || nData === void 0 ? void 0 : nData.data, true)
                } });
        }
        return c;
    });
    return { posts: newData };
};
var mergeComment = function (pageData, comment, mode) {
    var _a, _b, _c, _d;
    if (mode === COMMENT_EDIT_MODE.add) {
        var calcPaging = (!!pageData ? __assign(__assign({}, pageData === null || pageData === void 0 ? void 0 : pageData.paging), { count: ((_a = pageData.paging) === null || _a === void 0 ? void 0 : _a.count) + 1, page: 1 }) : getInitialPaging());
        var calcData = (_b = __spreadArray([
            comment
        ], (pageData === null || pageData === void 0 ? void 0 : pageData.data) || [], true)) === null || _b === void 0 ? void 0 : _b.slice(0, COMMENT_OFFSET);
        return {
            pageModel: {
                paging: calcPaging,
                data: calcData
            }
        };
    }
    else if (mode === COMMENT_EDIT_MODE.edit) {
        return {
            pageModel: __assign(__assign({}, pageData), { data: (_c = pageData === null || pageData === void 0 ? void 0 : pageData.data) === null || _c === void 0 ? void 0 : _c.map(function (c) {
                    var _a, _b;
                    if (c.id === (comment === null || comment === void 0 ? void 0 : comment.id)) {
                        return comment;
                    }
                    if (c.id === comment.parentId) {
                        return __assign(__assign({}, c), { comments: __assign(__assign({}, c === null || c === void 0 ? void 0 : c.comments), { data: (_b = (_a = c === null || c === void 0 ? void 0 : c.comments) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (sub) {
                                    if ((sub === null || sub === void 0 ? void 0 : sub.id) === (comment === null || comment === void 0 ? void 0 : comment.id)) {
                                        return comment;
                                    }
                                    return sub;
                                }) }) });
                    }
                    return c;
                }) })
        };
    }
    else if (mode === COMMENT_EDIT_MODE.answer) {
        return {
            pageModel: __assign(__assign({}, pageData), { data: (_d = pageData === null || pageData === void 0 ? void 0 : pageData.data) === null || _d === void 0 ? void 0 : _d.map(function (c) {
                    var _a, _b, _c, _d, _e;
                    if (c.id === (comment === null || comment === void 0 ? void 0 : comment.parentId)) {
                        var isEmptySubcomment = !(c === null || c === void 0 ? void 0 : c.comments);
                        var parentComment = __assign(__assign({}, c), { commentsCount: (c === null || c === void 0 ? void 0 : c.commentsCount) + 1 });
                        var newAnswer = comment;
                        return __assign(__assign({}, parentComment), { commentsCount: (c === null || c === void 0 ? void 0 : c.commentsCount) + 1, comments: isEmptySubcomment ? {
                                data: [newAnswer],
                                paging: getInitialPaging(true)
                            } : {
                                paging: __assign(__assign({}, (_a = parentComment === null || parentComment === void 0 ? void 0 : parentComment.comments) === null || _a === void 0 ? void 0 : _a.paging), { offset: SUB_COMMENT_OFFSET, page: 1, count: ((_c = (_b = parentComment === null || parentComment === void 0 ? void 0 : parentComment.comments) === null || _b === void 0 ? void 0 : _b.paging) === null || _c === void 0 ? void 0 : _c.count) + 1 }),
                                data: (_e = __spreadArray([
                                    newAnswer
                                ], (_d = parentComment === null || parentComment === void 0 ? void 0 : parentComment.comments) === null || _d === void 0 ? void 0 : _d.data, true)) === null || _e === void 0 ? void 0 : _e.slice(0, SUB_COMMENT_OFFSET)
                            } });
                    }
                    return c;
                }) })
        };
    }
};
var chatApiMethods = {
    post: (_a = urlApi()) === null || _a === void 0 ? void 0 : _a.fetchPostsMessages,
    team: (_b = urlApi()) === null || _b === void 0 ? void 0 : _b.fetchChannelMessages,
};
export function fetchInitChatData(_a) {
    var entityId = _a.entityId, entityType = _a.entityType, longreadId = _a.longreadId;
    return function (dispatch, getState) {
        var _a, _b, _c;
        var currState = getState();
        var _d = currState.chat, filter = _d.filter, parentFilter = _d.parentFilter, permissions = _d.permissions;
        var lgid = longreadId;
        var postsIds = (_c = (_b = (_a = currState === null || currState === void 0 ? void 0 : currState.longreadposts[lgid]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.map(function (post) { return post === null || post === void 0 ? void 0 : post.postId; });
        if (!(postsIds === null || postsIds === void 0 ? void 0 : postsIds.length)) {
            return;
        }
        var params = entityType === COMMENTS_ALLOWED_TYPE.post ? {
            entityIds: postsIds,
            entityType: entityType,
            limit: COMMENT_INIT_OFFSET
        } : __assign(__assign({ entityId: entityId, entityType: entityType }, filter), (parentFilter ? { parentId: parentFilter } : {}));
        dispatch({
            type: FETCH_INIT_CHAT_DATA,
        });
        chatApiMethods[entityType](__assign({}, params))
            .then(function (res) {
            if (res.status === 200) {
                return res.json();
            }
            else {
                dispatch({
                    type: FETCH_INIT_CHAT_DATA_REJECTED,
                });
            }
        })
            .then(function (response) {
            dispatch({
                type: FETCH_INIT_CHAT_DATA_SUCCESS,
                payload: { posts: response.map(function (p) {
                        return __assign(__assign({}, p), { pageModel: {
                                paging: p.pageModel.paging,
                                data: [] // При первом запросе не отображаем комменты
                            } });
                    }) },
            });
        });
    };
}
export function fetchChatData(_a) {
    var entityId = _a.entityId, entityType = _a.entityType, longreadId = _a.longreadId;
    return function (dispatch, getState) {
        var _a, _b, _c;
        var currState = getState();
        var _d = currState.chat, filter = _d.filter, parentFilter = _d.parentFilter, permissions = _d.permissions, posts = _d.posts;
        var lgid = longreadId;
        var currentPostId = (_c = (_b = (_a = currState === null || currState === void 0 ? void 0 : currState.longreadposts[lgid]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.find(function (post) { return (post === null || post === void 0 ? void 0 : post.postId) === entityId; });
        if (!currentPostId) {
            return;
        }
        var params = entityType === COMMENTS_ALLOWED_TYPE.post ? {
            entityIds: [currentPostId === null || currentPostId === void 0 ? void 0 : currentPostId.postId],
            entityType: entityType,
            limit: COMMENT_OFFSET
        } : __assign(__assign({ entityId: entityId, entityType: entityType }, filter), (parentFilter ? { parentId: parentFilter } : {}));
        dispatch({
            type: FETCH_CHAT_DATA
        });
        chatApiMethods[entityType](__assign({}, params))
            .then(function (res) {
            if (res.status === 200) {
                return res.json();
            }
            else {
                dispatch({
                    type: FETCH_CHAT_DATA_REJECTED,
                });
            }
        })
            .then(function (response) {
            var newPosts = __spreadArray([], posts, true);
            var index = newPosts === null || newPosts === void 0 ? void 0 : newPosts.findIndex(function (post) { return (post === null || post === void 0 ? void 0 : post.entityId) === entityId; });
            newPosts[index] = response === null || response === void 0 ? void 0 : response[0];
            dispatch({
                type: FETCH_CHAT_DATA_SUCCESS,
                payload: { posts: newPosts },
            });
        });
    };
}
export function fetchMoreChatData(_a) {
    var entityId = _a.entityId, entityType = _a.entityType, offset = _a.offset, page = _a.page;
    return function (dispatch, getState) {
        var currState = getState();
        var _a = currState.chat, filter = _a.filter, posts = _a.posts, isCreated = _a.isCreated, parentFilter = _a.parentFilter;
        var cData = posts;
        dispatch({
            type: FETCH_MORE_CHAT_DATA,
        });
        urlApi().fetchChannelMessages({
            entityId: entityId,
            entityType: entityType,
            page: page,
            offset: offset,
            limit: COMMENT_OFFSET
        })
            .then(function (res) {
            if (res.status === 200) {
                return res.json();
            }
        })
            .then(function (nData) {
            dispatch({
                type: FETCH_MORE_CHAT_DATA_SUCCESS,
                payload: mergeMore({ entityId: entityId, entityType: entityType, cData: cData, nData: nData })
            });
        });
    };
}
export function fetchMoreTreeComments(_a) {
    var entityId = _a.entityId, parentId = _a.parentId, entityType = _a.entityType, parentFilter = _a.parentFilter, postEntityId = _a.postEntityId;
    return function (dispatch, getState) {
        var currState = getState();
        var posts = currState.chat.posts;
        dispatch({
            type: FETCH_MORE_COMMENTS,
        });
        urlApi().fetchChannelMessages(__assign({ entityId: entityId, parentId: parentId, entityType: entityType }, parentFilter))
            .then(function (res) { return res.json(); })
            .then(function (res) {
            var _a, _b, _c, _d, _e, _f, _g;
            var newData = __spreadArray([], posts, true);
            var postIdx = newData === null || newData === void 0 ? void 0 : newData.findIndex(function (post) { return (post === null || post === void 0 ? void 0 : post.entityId) === postEntityId; });
            var parentIdx = (_c = (_b = (_a = newData[postIdx]) === null || _a === void 0 ? void 0 : _a.pageModel) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.findIndex(function (parent) { return (parent === null || parent === void 0 ? void 0 : parent.id) === parentId; });
            var newParents = __spreadArray([], (_e = (_d = newData[postIdx]) === null || _d === void 0 ? void 0 : _d.pageModel) === null || _e === void 0 ? void 0 : _e.data, true);
            var newComments = __assign({}, (_f = newParents[parentIdx]) === null || _f === void 0 ? void 0 : _f.comments);
            newParents[parentIdx] = __assign(__assign({}, newParents[parentIdx]), { comments: {
                    paging: res.paging,
                    data: __spreadArray(__spreadArray([], newComments === null || newComments === void 0 ? void 0 : newComments.data, true), res.data, true)
                } });
            newData[postIdx] = __assign(__assign({}, newData[postIdx]), { pageModel: __assign(__assign({}, (_g = newData[postIdx]) === null || _g === void 0 ? void 0 : _g.pageModel), { data: newParents }) });
            dispatch({
                type: FETCH_MORE_COMMENTS_SUCCESS,
                payload: {
                    posts: newData
                }
            });
        });
    };
}
export function updateCommentStart(_a) {
    var entityId = _a.entityId, postEntityId = _a.postEntityId, comment = _a.comment, mode = _a.mode;
    return function (dispatch, getState) {
        var currState = getState();
        var _a = currState.chat, posts = _a.posts, permissions = _a.permissions, answerId = _a.answerId;
        var isFirstCom = isFirstComment(posts, postEntityId);
        var result;
        if (isFirstCom) {
            result = {
                posts: __spreadArray(__spreadArray([], posts, true), [__assign({ entityId: postEntityId, entityType: permissions === null || permissions === void 0 ? void 0 : permissions.entityType }, mergeComment(undefined, comment, mode))], false),
                creatingId: comment.id,
            };
        }
        else {
            result = {
                posts: posts === null || posts === void 0 ? void 0 : posts.map(function (post) {
                    if ((post === null || post === void 0 ? void 0 : post.entityId) === postEntityId) {
                        return __assign({ entityId: postEntityId, entityType: permissions === null || permissions === void 0 ? void 0 : permissions.entityType }, mergeComment(post.pageModel, comment, mode));
                    }
                    return post;
                }),
                creatingId: comment.id,
            };
        }
        dispatch({
            type: UPDATE_COMMENT_START,
            payload: result
        });
        setTimeout(function () {
            dispatch({
                type: UPDATE_COMMENT_END,
                payload: result,
            });
        }, 5000);
    };
}
;
export function onUpdateChatState(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_CHAT_DATA,
            payload: data
        });
    };
}
export function onUpdatePermissions(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_PERMISSIONS,
            payload: data
        });
    };
}
export function onUpdateScroll(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_SCROLL,
            payload: data
        });
    };
}
export function updateCommentStatus(_a) {
    var postEntityId = _a.postEntityId, commentId = _a.commentId, parentId = _a.parentId;
    return function (dispatch, getState) {
        var currState = getState();
        var posts = currState.chat.posts;
        var newPosts = posts === null || posts === void 0 ? void 0 : posts.map(function (post) {
            var _a, _b;
            if ((post === null || post === void 0 ? void 0 : post.entityId) === postEntityId) {
                return __assign(__assign({}, post), { pageModel: __assign(__assign({}, post === null || post === void 0 ? void 0 : post.pageModel), { data: (_b = (_a = post === null || post === void 0 ? void 0 : post.pageModel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (i) {
                            var _a, _b;
                            if ((i === null || i === void 0 ? void 0 : i.id) === commentId) {
                                return __assign(__assign({}, i), { status: 1 });
                            }
                            if (i.id === parentId) {
                                return __assign(__assign({}, i), { comments: __assign(__assign({}, i === null || i === void 0 ? void 0 : i.comments), { data: (_b = (_a = i === null || i === void 0 ? void 0 : i.comments) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (sub) {
                                            if (sub.id === commentId) {
                                                return __assign(__assign({}, sub), { status: 1 });
                                            }
                                            return sub;
                                        }) }) });
                            }
                            return i;
                        }) }) });
            }
            return post;
        });
        dispatch({
            type: UPDATE_COMMENT_STATUS,
            payload: { posts: newPosts },
        });
        return;
    };
}
export function onReset() {
    return function (dispatch) {
        dispatch({
            type: RESET_STATE,
            payload: null
        });
    };
}
//# sourceMappingURL=chatActions.js.mapvar __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import React from 'react';
import urlApi from './urlApi';
import { COMMENT_EDIT_MODE, COMMENT_INIT_OFFSET, COMMENT_OFFSET, COMMENTS_ALLOWED_TYPE, SUB_COMMENT_OFFSET } from '../components/desktopApp/comments/const/const';
import { API } from '@brg/api';
export var FETCH_INIT_CHAT_DATA = 'FETCH_INIT_CHAT_DATA';
export var FETCH_INIT_CHAT_DATA_SUCCESS = 'FETCH_INIT_CHAT_DATA_SUCCESS';
export var FETCH_INIT_CHAT_DATA_REJECTED = 'FETCH_INIT_CHAT_DATA_REJECTED';
export var FETCH_CHAT_DATA = 'FETCH_CHAT_DATA';
export var FETCH_CHAT_DATA_SUCCESS = 'FETCH_CHAT_DATA_SUCCESS';
export var FETCH_CHAT_DATA_REJECTED = 'FETCH_CHAT_DATA_REJECTED';
export var FETCH_MORE_CHAT_DATA = 'FETCH_CHAT_DATA';
export var FETCH_MORE_CHAT_DATA_SUCCESS = 'FETCH_CHAT_DATA_SUCCESS';
export var FETCH_MORE_CHAT_DATA_REJECTED = 'FETCH_CHAT_DATA_REJECTED';
export var FETCH_MORE_COMMENTS = 'FETCH_MORE_COMMENTS';
export var FETCH_MORE_COMMENTS_SUCCESS = 'FETCH_MORE_COMMENTS_SUCCESS';
export var FETCH_MORE_COMMENTS_REJECT = 'FETCH_MORE_COMMENTS_REJECT';
export var UPDATE_COMMENT_START = 'UPDATE_COMMENT_START';
export var UPDATE_COMMENT_END = 'UPDATE_COMMENT_END';
export var UPDATE_CHAT_DATA = 'UPDATE_CHAT_DATA';
export var UPDATE_COMMENT_STATUS = 'UPDATE_COMMENT_STATUS';
export var UPDATE_PERMISSIONS = 'UPDATE_PERMISSIONS';
export var UPDATE_SCROLL = 'UPDATE_SCROLL';
export var RESET_STATE = 'RESET_STATE';
var isFirstComment = function (posts, postEntityId) {
    return !(posts === null || posts === void 0 ? void 0 : posts.find(function (p) { return (p === null || p === void 0 ? void 0 : p.entityId) === postEntityId; }));
};
var isFirstSubComment = function (posts, postEntityId, answerId) {
    var _a, _b;
    var post = posts === null || posts === void 0 ? void 0 : posts.find(function (p) { return (p === null || p === void 0 ? void 0 : p.entityId) === postEntityId; });
    var comment = (_b = (_a = post === null || post === void 0 ? void 0 : post.pageModel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.find(function (comment) {
        return (comment === null || comment === void 0 ? void 0 : comment.id) === answerId;
    });
    var subComments = comment === null || comment === void 0 ? void 0 : comment.comments;
    return subComments === null;
};
var getInitialPaging = function (isAnswer) {
    if (isAnswer) {
        return {
            count: 1,
            limit: SUB_COMMENT_OFFSET,
            page: 1,
            pages: 1,
            offset: 0
        };
    }
    return {
        count: 1,
        limit: COMMENT_OFFSET,
        page: 1,
        pages: 1,
        offset: 0
    };
};
var mergeMore = function (_a) {
    var entityId = _a.entityId, entityType = _a.entityType, cData = _a.cData, nData = _a.nData;
    var newData = cData.map(function (c) {
        var _a, _b, _c;
        if (c.entityId === entityId) {
            return __assign(__assign({}, c), { pageModel: {
                    paging: nData.paging,
                    data: __spreadArray(__spreadArray([], (!!((_b = (_a = c === null || c === void 0 ? void 0 : c.pageModel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.length) ? (_c = c === null || c === void 0 ? void 0 : c.pageModel) === null || _c === void 0 ? void 0 : _c.data : []), true), nData === null || nData === void 0 ? void 0 : nData.data, true)
                } });
        }
        return c;
    });
    return { posts: newData };
};
var mergeComment = function (pageData, comment, mode) {
    var _a, _b, _c, _d;
    if (mode === COMMENT_EDIT_MODE.add) {
        var calcPaging = (!!pageData ? __assign(__assign({}, pageData === null || pageData === void 0 ? void 0 : pageData.paging), { count: ((_a = pageData.paging) === null || _a === void 0 ? void 0 : _a.count) + 1, page: 1 }) : getInitialPaging());
        var calcData = (_b = __spreadArray([
            comment
        ], (pageData === null || pageData === void 0 ? void 0 : pageData.data) || [], true)) === null || _b === void 0 ? void 0 : _b.slice(0, COMMENT_OFFSET);
        return {
            pageModel: {
                paging: calcPaging,
                data: calcData
            }
        };
    }
    else if (mode === COMMENT_EDIT_MODE.edit) {
        return {
            pageModel: __assign(__assign({}, pageData), { data: (_c = pageData === null || pageData === void 0 ? void 0 : pageData.data) === null || _c === void 0 ? void 0 : _c.map(function (c) {
                    var _a, _b;
                    if (c.id === (comment === null || comment === void 0 ? void 0 : comment.id)) {
                        return comment;
                    }
                    if (c.id === comment.parentId) {
                        return __assign(__assign({}, c), { comments: __assign(__assign({}, c === null || c === void 0 ? void 0 : c.comments), { data: (_b = (_a = c === null || c === void 0 ? void 0 : c.comments) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (sub) {
                                    if ((sub === null || sub === void 0 ? void 0 : sub.id) === (comment === null || comment === void 0 ? void 0 : comment.id)) {
                                        return comment;
                                    }
                                    return sub;
                                }) }) });
                    }
                    return c;
                }) })
        };
    }
    else if (mode === COMMENT_EDIT_MODE.answer) {
        return {
            pageModel: __assign(__assign({}, pageData), { data: (_d = pageData === null || pageData === void 0 ? void 0 : pageData.data) === null || _d === void 0 ? void 0 : _d.map(function (c) {
                    var _a, _b, _c, _d, _e;
                    if (c.id === (comment === null || comment === void 0 ? void 0 : comment.parentId)) {
                        var isEmptySubcomment = !(c === null || c === void 0 ? void 0 : c.comments);
                        var parentComment = __assign(__assign({}, c), { commentsCount: (c === null || c === void 0 ? void 0 : c.commentsCount) + 1 });
                        var newAnswer = comment;
                        return __assign(__assign({}, parentComment), { commentsCount: (c === null || c === void 0 ? void 0 : c.commentsCount) + 1, comments: isEmptySubcomment ? {
                                data: [newAnswer],
                                paging: getInitialPaging(true)
                            } : {
                                paging: __assign(__assign({}, (_a = parentComment === null || parentComment === void 0 ? void 0 : parentComment.comments) === null || _a === void 0 ? void 0 : _a.paging), { offset: SUB_COMMENT_OFFSET, page: 1, count: ((_c = (_b = parentComment === null || parentComment === void 0 ? void 0 : parentComment.comments) === null || _b === void 0 ? void 0 : _b.paging) === null || _c === void 0 ? void 0 : _c.count) + 1 }),
                                data: (_e = __spreadArray([
                                    newAnswer
                                ], (_d = parentComment === null || parentComment === void 0 ? void 0 : parentComment.comments) === null || _d === void 0 ? void 0 : _d.data, true)) === null || _e === void 0 ? void 0 : _e.slice(0, SUB_COMMENT_OFFSET)
                            } });
                    }
                    return c;
                }) })
        };
    }
};
var chatApiMethods = {
    post: (_a = urlApi()) === null || _a === void 0 ? void 0 : _a.fetchPostsMessages,
    team: (_b = urlApi()) === null || _b === void 0 ? void 0 : _b.fetchChannelMessages,
};
export function fetchInitChatData(_a) {
    var entityId = _a.entityId, entityType = _a.entityType, longreadId = _a.longreadId;
    return function (dispatch, getState) {
        var _a, _b, _c;
        var currState = getState();
        var _d = currState.chat, filter = _d.filter, parentFilter = _d.parentFilter, permissions = _d.permissions;
        var lgid = longreadId;
        var postsIds = (_c = (_b = (_a = currState === null || currState === void 0 ? void 0 : currState.longreadposts[lgid]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.map(function (post) { return post === null || post === void 0 ? void 0 : post.postId; });
        if (!(postsIds === null || postsIds === void 0 ? void 0 : postsIds.length)) {
            return;
        }
        var params = entityType === COMMENTS_ALLOWED_TYPE.post ? {
            entityIds: postsIds,
            entityType: entityType,
            limit: COMMENT_INIT_OFFSET
        } : __assign(__assign({ entityId: entityId, entityType: entityType }, filter), (parentFilter ? { parentId: parentFilter } : {}));
        dispatch({
            type: FETCH_INIT_CHAT_DATA,
        });
        chatApiMethods[entityType](__assign({}, params))
            .then(function (res) {
            if (res.status === 200) {
                return res.json();
            }
            else {
                dispatch({
                    type: FETCH_INIT_CHAT_DATA_REJECTED,
                });
            }
        })
            .then(function (response) {
            dispatch({
                type: FETCH_INIT_CHAT_DATA_SUCCESS,
                payload: { posts: response.map(function (p) {
                        return __assign(__assign({}, p), { pageModel: {
                                paging: p.pageModel.paging,
                                data: [] // При первом запросе не отображаем комменты
                            } });
                    }) },
            });
        });
    };
}
export function fetchChatData(_a) {
    var entityId = _a.entityId, entityType = _a.entityType, longreadId = _a.longreadId;
    return function (dispatch, getState) {
        var _a, _b, _c;
        var currState = getState();
        var _d = currState.chat, filter = _d.filter, parentFilter = _d.parentFilter, permissions = _d.permissions, posts = _d.posts;
        var lgid = longreadId;
        var currentPostId = (_c = (_b = (_a = currState === null || currState === void 0 ? void 0 : currState.longreadposts[lgid]) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.find(function (post) { return (post === null || post === void 0 ? void 0 : post.postId) === entityId; });
        if (!currentPostId) {
            return;
        }
        var params = entityType === COMMENTS_ALLOWED_TYPE.post ? {
            entityIds: [currentPostId === null || currentPostId === void 0 ? void 0 : currentPostId.postId],
            entityType: entityType,
            limit: COMMENT_OFFSET
        } : __assign(__assign({ entityId: entityId, entityType: entityType }, filter), (parentFilter ? { parentId: parentFilter } : {}));
        dispatch({
            type: FETCH_CHAT_DATA
        });
        chatApiMethods[entityType](__assign({}, params))
            .then(function (res) {
            if (res.status === 200) {
                return res.json();
            }
            else {
                dispatch({
                    type: FETCH_CHAT_DATA_REJECTED,
                });
            }
        })
            .then(function (response) {
            var newPosts = __spreadArray([], posts, true);
            var index = newPosts === null || newPosts === void 0 ? void 0 : newPosts.findIndex(function (post) { return (post === null || post === void 0 ? void 0 : post.entityId) === entityId; });
            newPosts[index] = response === null || response === void 0 ? void 0 : response[0];
            dispatch({
                type: FETCH_CHAT_DATA_SUCCESS,
                payload: { posts: newPosts },
            });
        });
    };
}
export function fetchMoreChatData(_a) {
    var entityId = _a.entityId, entityType = _a.entityType, offset = _a.offset, page = _a.page;
    return function (dispatch, getState) {
        var currState = getState();
        var _a = currState.chat, filter = _a.filter, posts = _a.posts, isCreated = _a.isCreated, parentFilter = _a.parentFilter;
        var cData = posts;
        dispatch({
            type: FETCH_MORE_CHAT_DATA,
        });
        urlApi().fetchChannelMessages({
            entityId: entityId,
            entityType: entityType,
            page: page,
            offset: offset,
            limit: COMMENT_OFFSET
        })
            .then(function (res) {
            if (res.status === 200) {
                return res.json();
            }
        })
            .then(function (nData) {
            dispatch({
                type: FETCH_MORE_CHAT_DATA_SUCCESS,
                payload: mergeMore({ entityId: entityId, entityType: entityType, cData: cData, nData: nData })
            });
        });
    };
}
export function fetchMoreTreeComments(_a) {
    var entityId = _a.entityId, parentId = _a.parentId, entityType = _a.entityType, parentFilter = _a.parentFilter, postEntityId = _a.postEntityId;
    return function (dispatch, getState) {
        var currState = getState();
        var posts = currState.chat.posts;
        dispatch({
            type: FETCH_MORE_COMMENTS,
        });
        urlApi().fetchChannelMessages(__assign({ entityId: entityId, parentId: parentId, entityType: entityType }, parentFilter))
            .then(function (res) { return res.json(); })
            .then(function (res) {
            var _a, _b, _c, _d, _e, _f, _g;
            var newData = __spreadArray([], posts, true);
            var postIdx = newData === null || newData === void 0 ? void 0 : newData.findIndex(function (post) { return (post === null || post === void 0 ? void 0 : post.entityId) === postEntityId; });
            var parentIdx = (_c = (_b = (_a = newData[postIdx]) === null || _a === void 0 ? void 0 : _a.pageModel) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.findIndex(function (parent) { return (parent === null || parent === void 0 ? void 0 : parent.id) === parentId; });
            var newParents = __spreadArray([], (_e = (_d = newData[postIdx]) === null || _d === void 0 ? void 0 : _d.pageModel) === null || _e === void 0 ? void 0 : _e.data, true);
            var newComments = __assign({}, (_f = newParents[parentIdx]) === null || _f === void 0 ? void 0 : _f.comments);
            newParents[parentIdx] = __assign(__assign({}, newParents[parentIdx]), { comments: {
                    paging: res.paging,
                    data: __spreadArray(__spreadArray([], newComments === null || newComments === void 0 ? void 0 : newComments.data, true), res.data, true)
                } });
            newData[postIdx] = __assign(__assign({}, newData[postIdx]), { pageModel: __assign(__assign({}, (_g = newData[postIdx]) === null || _g === void 0 ? void 0 : _g.pageModel), { data: newParents }) });
            dispatch({
                type: FETCH_MORE_COMMENTS_SUCCESS,
                payload: {
                    posts: newData
                }
            });
        });
    };
}
export function updateCommentStart(_a) {
    var entityId = _a.entityId, postEntityId = _a.postEntityId, comment = _a.comment, mode = _a.mode;
    return function (dispatch, getState) {
        var currState = getState();
        var _a = currState.chat, posts = _a.posts, permissions = _a.permissions, answerId = _a.answerId;
        var isFirstCom = isFirstComment(posts, postEntityId);
        var result;
        if (isFirstCom) {
            result = {
                posts: __spreadArray(__spreadArray([], posts, true), [__assign({ entityId: postEntityId, entityType: permissions === null || permissions === void 0 ? void 0 : permissions.entityType }, mergeComment(undefined, comment, mode))], false),
                creatingId: comment.id,
            };
        }
        else {
            result = {
                posts: posts === null || posts === void 0 ? void 0 : posts.map(function (post) {
                    if ((post === null || post === void 0 ? void 0 : post.entityId) === postEntityId) {
                        return __assign({ entityId: postEntityId, entityType: permissions === null || permissions === void 0 ? void 0 : permissions.entityType }, mergeComment(post.pageModel, comment, mode));
                    }
                    return post;
                }),
                creatingId: comment.id,
            };
        }
        dispatch({
            type: UPDATE_COMMENT_START,
            payload: result
        });
        setTimeout(function () {
            dispatch({
                type: UPDATE_COMMENT_END,
                payload: result,
            });
        }, 5000);
    };
}
;
export function onUpdateChatState(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_CHAT_DATA,
            payload: data
        });
    };
}
export function onUpdatePermissions(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_PERMISSIONS,
            payload: data
        });
    };
}
export function onUpdateScroll(data) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_SCROLL,
            payload: data
        });
    };
}
export function updateCommentStatus(_a) {
    var postEntityId = _a.postEntityId, commentId = _a.commentId, parentId = _a.parentId;
    return function (dispatch, getState) {
        var currState = getState();
        var posts = currState.chat.posts;
        var newPosts = posts === null || posts === void 0 ? void 0 : posts.map(function (post) {
            var _a, _b;
            if ((post === null || post === void 0 ? void 0 : post.entityId) === postEntityId) {
                return __assign(__assign({}, post), { pageModel: __assign(__assign({}, post === null || post === void 0 ? void 0 : post.pageModel), { data: (_b = (_a = post === null || post === void 0 ? void 0 : post.pageModel) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (i) {
                            var _a, _b;
                            if ((i === null || i === void 0 ? void 0 : i.id) === commentId) {
                                return __assign(__assign({}, i), { status: 1 });
                            }
                            if (i.id === parentId) {
                                return __assign(__assign({}, i), { comments: __assign(__assign({}, i === null || i === void 0 ? void 0 : i.comments), { data: (_b = (_a = i === null || i === void 0 ? void 0 : i.comments) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.map(function (sub) {
                                            if (sub.id === commentId) {
                                                return __assign(__assign({}, sub), { status: 1 });
                                            }
                                            return sub;
                                        }) }) });
                            }
                            return i;
                        }) }) });
            }
            return post;
        });
        dispatch({
            type: UPDATE_COMMENT_STATUS,
            payload: { posts: newPosts },
        });
        return;
    };
}
export function onReset() {
    return function (dispatch) {
        dispatch({
            type: RESET_STATE,
            payload: null
        });
    };
}
//# sourceMappingURL=chatActions.js.map